/**
 * @file SearchComponent.js
 * @description a search text box with icon
 * @component
 *
 * @param {string} initialValue - the initial value for the search term
 * @param {function} onSearch - A callback function to handle the change of the term
 * @param {string} placeholder - the placeholder text for the text box
 * @param {boolean} disabled - if the search box should be disabled
 * @param {boolean} autoFocus - if the search box should have focus
 */

import styles from "./SearchComponent.module.scss";

const SearchComponent = ({
  initialValue,
  onSearch,
  placeholder = "Search",
  disabled = false,
  autoFocus = false }) => {

  const handleSearchTermChange = (e) => {
    onSearch(e.target.value);
  }

  return (
    <div className={styles.searchWrapper}>
      <input
        type="text"
        className={styles.searchInput}
        placeholder={placeholder}
        value={initialValue}
        onChange={handleSearchTermChange}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      <span className={styles.searchIcon}><i className="bi bi-search"></i></span>
    </div>
  );
}

export default SearchComponent;
